import classnames from 'classnames/bind'
import { format } from 'date-fns'
import { useRouter } from 'next/router'

// Components
import Icon from '@/assets/icons'
import Insight from '@/components/shared/Insight'
import { GtmClickLiveRoomLiveStatus, GtmClickLiveRoomPosition } from '@/constants/gtmEvent'

// Styles
import styles from './style.module.scss'

// Constants
import { ROOM_LIVE_TYPE } from '@/constants/liveRoom'
import { handleGtmClickLiveRoom } from '@/methods/handleGtmEvent'
import { goToLiveRoom } from '@/methods/goToLiveRoom'

const cx = classnames.bind(styles)

interface IProps {
  isSingle: boolean
  roomId: string
  title: string
  kolName: string
  startTime: string
  liveType: number
  liveSourceType: number
}

const LiveRoom = (props: IProps) => {
  const { isSingle, roomId, title, kolName, startTime, liveType, liveSourceType } = props
  const router = useRouter()

  const handleClick = () => {
    goToLiveRoom({ router, roomId, liveType, liveSourceType })

    handleGtmClickLiveRoom({
      roomId: roomId,
      position: GtmClickLiveRoomPosition.LIVE_PREVIEW,
      liveStatus: liveType === ROOM_LIVE_TYPE.CURRENT ? GtmClickLiveRoomLiveStatus.LIVE : GtmClickLiveRoomLiveStatus.PREVIEW,
    })
  }

  return (
    <div onClick={handleClick} className={cx('live-room', { 'live-room--single': isSingle, 'live-room--multiple': !isSingle })}>
      <div className={cx('live-room__content')}>
        <div className={cx('live-room__content-header')}>
          <div className={cx('live-room__date-time')}>{format(new Date(startTime), 'yyyy-MM-dd HH:mm')}</div>
          {liveType === ROOM_LIVE_TYPE.CURRENT && (
            <div className={cx('live-room__live-status')}>
              <Insight status='view' theme='gray' position='absolute' top='0px' left='0px' />
            </div>
          )}
        </div>

        <div className={cx('live-room__kol-name')}>{kolName}</div>
        <div className={cx('live-room__title')}>{title}</div>
      </div>
      <div className={cx('live-room__icon')}>
        <Icon.ArrowRight />
      </div>
    </div>
  )
}

export default LiveRoom
